import type { LiveCity } from '@/types';

/**
 * Shown only when the live-cities request fails, so the home page never
 * renders empty. The source of truth is the admin "Live cities" page.
 */
export const FALLBACK_LIVE_CITIES: LiveCity[] = [
  {
    _id: 'fallback-agra',
    name: 'Agra',
    region: 'Uttar Pradesh',
    imageUrl: '/images/destinations/agra.jpg',
    highlight: 'Taj Mahal & Mughal heritage',
  },
  {
    _id: 'fallback-delhi',
    name: 'Delhi',
    region: 'Delhi',
    imageUrl: '/images/destinations/delhi.jpg',
    highlight: 'Old Delhi lanes & monuments',
  },
  {
    _id: 'fallback-varanasi',
    name: 'Varanasi',
    region: 'Uttar Pradesh',
    imageUrl: '/images/destinations/varanasi.jpg',
    highlight: 'Ganga ghats & spiritual walks',
  },
  {
    _id: 'fallback-mathura',
    name: 'Mathura',
    region: 'Uttar Pradesh',
    imageUrl: '/images/destinations/mathura.jpg',
    highlight: 'Krishna birthplace & temples',
  },
  {
    _id: 'fallback-vrindavan',
    name: 'Vrindavan',
    region: 'Uttar Pradesh',
    imageUrl: '/images/destinations/vrindavan.jpg',
    highlight: 'Temple trails & bhajan evenings',
  },
  {
    _id: 'fallback-jaipur',
    name: 'Jaipur',
    region: 'Rajasthan',
    imageUrl: '/images/destinations/jaipur.jpg',
    highlight: 'Pink City forts & bazaars',
  },
];

export const CITY_IMAGE_PLACEHOLDER = '/images/destinations/jaipur.jpg';
